import React, { useState, useEffect } from "react";
import Select from "react-select";
import AdminServices from "services/AdminServices";

const SelectAllCityState = ({
  onSelectState,
  name,
  label,
  selectOptions,
  selectedServiceState,
  setSelectedServiceState,
}) => {
  const [states, setStates] = useState([]);
  const SELECT_ALL_OPTION = { value: "select_all", label: "Select All" };

  useEffect(() => {
    const fetchStates = async () => {
      try {
        const response = await AdminServices.getAllState();
        if (Array.isArray(response.data)) {
          setStates(
            response.data.map((state) => ({
              value: state.id_state,
              label: state.name,
            }))
          );
        } else {
          console.error("API Response is not an array:", response);
        }
      } catch (error) {
        console.error("Error fetching states:", error);
      }
    };

    fetchStates();
  }, []);

  const normalizeSelectOptions = (options) => {
    if (!Array.isArray(options)) return [];
    return options
      .map((option) => {
        if (typeof option === "object" && option.value && option.label) {
          return option;
        } else if (typeof option === "string" || typeof option === "number") {
          const matchedState = states.find(
            (state) => state.value.toString() === option.toString()
          );
          return matchedState || { value: option, label: `State ${option}` };
        }
        return null;
      })
      .filter(Boolean);
  };

  const getCombinedOptions = () => {
    const normalizedOptions = normalizeSelectOptions(selectOptions);
    const optionSet = new Map();
    [SELECT_ALL_OPTION, ...normalizedOptions].forEach((option) => {
      if (option && option.value) optionSet.set(option.value, option);
    });
    return Array.from(optionSet.values());
  };

  const mapToOption = (value) => {
    if (value && typeof value === "object") return value;

    return (
      states.find((state) => state.value?.toString() === value?.toString()) ||
      selectOptions.find(
        (option) => option.value?.toString() === value?.toString()
      )
    );
  };

  const mapSelectedStateToOptions = () => {
    if (!Array.isArray(selectedServiceState)) return [];
    return selectedServiceState.map(mapToOption).filter(Boolean);
  };

  const handleStateSelect = (selectedOptions) => {
    const isSelectAllSelected = selectedOptions.some(
      (option) => option.value === SELECT_ALL_OPTION.value
    );

    if (isSelectAllSelected) {
      const allStates = states.map((state) => ({
        value: state.value,
        label: state.label,
      }));
      setSelectedServiceState(allStates);
      onSelectState(allStates);
    } else {
      const selectedValues = selectedOptions.map((option) => ({
        value: option.value,
        label: option.label,
      }));
      setSelectedServiceState(selectedValues);
      onSelectState(selectedValues);
    }
  };

  const customStyles = {
    indicatorsContainer: (provided) => ({
      ...provided,
      padding: "0", // Optional: Adjust padding
    }),
    indicatorSeparator: () => ({
      display: "none", // Removes the separator line
    }),
  };

  return (
    <div>
      {label && <label className="block text-sm font-medium">{label}</label>}
      <Select
        isMulti
        name={name}
        options={getCombinedOptions()}
        value={mapSelectedStateToOptions()}
        onChange={handleStateSelect}
        placeholder="--Choose States--"
        classNamePrefix="react-select"
        styles={customStyles}
        className="border h-10 text-sm focus:outline-none block w-full bg-white-100 dark:bg-white border-transparent focus:bg-white"
      />
    </div>
  );
};

export default SelectAllCityState;
